import appendQuery from 'append-query';
import { PRODUCT_TYPES } from '@nerdwallet/nw-api-sdk/marketplace';
import { getApplyLink } from '@nerdwallet/marketplace/selectors/common';
import { getIssuerName, getName // Only applicable for Homeownership fixtures!
, getApplyDisclaimerText, getApplyText } from '@nerdwallet/marketplace/selectors/mortgages';
import { isLegacyHomeownershipEntity } from '@nerdwallet/marketplace/utils/mortgages';
var DEFAULT_APPLY_TEXT = 'Learn More';

var getIssuerAnnotation = function getIssuerAnnotation(marketplaceEntity) {
  var issuerName = getIssuerName(marketplaceEntity);
  return issuerName && "at ".concat(issuerName);
};

export default (function (_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  var shouldUseLegacyFormats = isLegacyHomeownershipEntity(marketplaceEntity);
  var link = getApplyLink(marketplaceEntity);

  if (link && shouldUseLegacyFormats) {
    // This is required for legacy, network-links to log events properly
    link = appendQuery(link, {
      product_type: PRODUCT_TYPES.MORTGAGES
    });
  }

  return {
    additionalEventData: {
      lender: getName(marketplaceEntity)
    },
    annotationText: shouldUseLegacyFormats ? getApplyDisclaimerText(marketplaceEntity) : getIssuerAnnotation(marketplaceEntity),
    link: link,
    text: shouldUseLegacyFormats ? getApplyText(marketplaceEntity) : DEFAULT_APPLY_TEXT,
    vertical: 'Mortgage Lender'
  };
});